import * as z from "zod/v4";
import { ProfileEmailSourceSchema } from "./profile-email-source.js";

const ProfileSchema_ = z.object({
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  emailSource: ProfileEmailSourceSchema,
  lastSeen: z.string(),
  emailOptIn: z.boolean().nullable(),
  firstSeen: z.string(),
});
export const ProfileSchema: z.ZodType<Profile> = ProfileSchema_;
export interface Profile extends z.infer<typeof ProfileSchema_> {}
